import Actions from '../../action'
import SuitStyle from '../../../config/suit_style.json'

const initialState = {
    isLoading: false,
    error: false,
    selectedCombination: {
        style: SuitStyle['style'].child[0],
        fit: SuitStyle['fit'].child[0],
        sleeve_buttons: SuitStyle['sleeve_buttons'].child[0],
        back_style: SuitStyle['back_style'].child[0],
        pocket: SuitStyle['pocket'].child[0],
        breast_pocket: SuitStyle['breast_pocket'].child[0],
        lapels: SuitStyle['lapels'].child[0],
        lapels_width: SuitStyle['lapels_width'].child[0]
    },
}
export default (state = initialState, action) => {
    switch (action.type) {
        case Actions.UPDATE_SUIT_STYLE: {
            const { selectedCombination } = state;
            return {
                ...state,
                selectedCombination: {
                    ...selectedCombination,
                    [action.key]: action.data,
                }
            };
        }
        case Actions.RESET_CANVAS: {
            return {
                ...state,
                ...initialState
            }
        } case Actions.RESET_STYLE: {
            return {
                ...state,
                ...initialState
            }
        }
        case Actions.EDIT_SELECTED_SUIT_COMBINATION: {
            return {
                ...state,
                selectedCombination: action.data,
            };
        }
        case Actions.EDIT_THREE_SUITS: {
            const { selectedCombination } = state;

            return {
                ...state,
                selectedCombination: {
                    ...selectedCombination,
                    vests: SuitStyle['vests'].child[1],
                }
            };
        }
        default:
            return state;
    }

};